module.exports = __webpack_public_path__ + "img/t1.271c89d0.jpg";